import { Chance } from "chance"
import { DictionaryBrand } from "etl/types";

const chance = new Chance();

export const dictionaryBrandFactoryMock = (howMany: number): DictionaryBrand[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/api/dictionary_brands/${index + 1}`,
		"@type": "DictionaryBrand",
		id: index + 1,
		libelle: chance.word(),
		hb_brand_id: chance.integer().toString(),
		hb_brand_libelle: chance.word(),
	}));
